import * as React from "react"
import { Redirect } from "@gatsbyjs/reach-router"
import { logout } from "@modules/auth"
import { useTrackSentry } from "@modules/auth/hooks/useTrackSentry"

export default function Logout() {
  const { stopTrackingSentry } = useTrackSentry()

  React.useEffect(() => {
    stopTrackingSentry()
    return logout()
  }, [])

  return <Redirect to="/dashboard/login" noThrow />
}
